import { doFetch } from "./apiFetchHelper";
const apiBase = "/api/attractions";

function fetchAllAttractions() {
  return doFetch(apiBase);
}

export default { fetchAllAttractions };
